import React from "react";
import { useTranslation } from "react-i18next";
import "./ATLTinkerpreneurPhasesRoadmap.css";

const PHASE_COLORS = [
  "#1083CE",
  "#20B373",
  "#B11C54",
  "#1083CE",
  "#20B373",
  "#B11C54",
];

function ATLTinkerpreneurPhasesRoadmap() {
  const { t } = useTranslation();
  const ns = "atl_tinkerpreneur_2026";

  const phases = [1, 2, 3, 4, 5, 6].map(function (no) {
    return {
      no,
      color: PHASE_COLORS[no - 1],
      workshops: t(`${ns}.phase_${no}_workshops`),
      title: t(`${ns}.phase_${no}_title`),
    };
  });

  return (
    <section className="tp26ph-section">
      <div className="tp26ph-wrap">
        <h2 className="text-center mar-b-10">{t(`${ns}.phases_heading`)}</h2>

        <div className="tp26ph-grid">
          {phases.map(function (ph) {
            return (
              <div
                key={ph.no}
                className="tp26ph-card"
                style={{ "--ph": ph.color }}
              >
                <div className="tp26ph-top">
                  <span className="tp26ph-no">{ph.no}</span>
                  <span className="tp26ph-ws">{ph.workshops}</span>
                </div>
                <h4>{ph.title}</h4>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ATLTinkerpreneurPhasesRoadmap;
